/**
 * Reset pagination parameters for our API by resetting corresponding inputs and the `data-ct-rest` attribute on the parent.
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 */
export function resetPagination(parent) {
    const { ctRest, ctRestInstance } = parent.dataset;
    const api = JSON.parse(ctRest);
    const offset = parent.querySelector(`.offset-posts[data-ct-rest-instance="${ctRestInstance}"]`);

    // reset pagination
    api.currentpage = 1;
    if (offset) {
        offset.value = 0;
    }

    parent.dataset.ctRest = JSON.stringify(api);
}
